import Vue from "vue";
import { AbacoWebModule, RouterReadyEvent, MenuItem } from '@abaco/web-common/src/app';
import globals from "./globals";
import myRoutes from "./routes";
import PoiVuexModule from './state';
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { createMenu } from './menu';
import PoiApi from './api/PoiApi';
import MenuModule, { MODULE_ID as MENU_MODULE_ID } from '@abaco/menu-module/src/modules/menu';
import FarmerRegistryModule from '@abaco/farm-registry/src/modules/farm-registry';
import MapModule from '@abaco/map-web-module/src/modules/map-web-module';
import GlobalStateModule from '@abaco/portal-global-state/src/modules/global-state';
import { ApplicationReadyEvent } from '@abaco/web-common/src/app/Application';
import SSOModule, { MODULE_ID as SSO_MODULE_ID } from "@abaco/sso-web-module/src/abaco-module";
import SsoVuexModule from '@abaco/sso-web-module/src/abaco-module/state';
import IconCategory from "./components/private/bookmarksIcons";


export const MODULE_ID = "poi_module";

const state = new PoiVuexModule();

export default class PoiModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    private pointOfInterestApi!: PoiApi;
    private iconCategory!: IconCategory;
    private apiCreated = false;
    ssoStore!: SsoVuexModule;

    readonly id = MODULE_ID;
    readonly routes = myRoutes;
    readonly globalComponents = globals;
    readonly vuexModule = state;
    additionalI18N = ['web-components']
    menu: MenuItem[] = [];

    dependsOn = {
        [MENU_MODULE_ID]: () => new MenuModule(),
        [FarmerRegistryModule.MODULE_ID]: () => new FarmerRegistryModule(),
        [MapModule.MODULE_ID]: () => new MapModule(),
        [GlobalStateModule.MODULE_ID]: () => new GlobalStateModule()
    }

    onApplicationReady(evt: ApplicationReadyEvent) {

        const ssoModule = evt.modules.find((m) => m.id === SSO_MODULE_ID) as SSOModule | undefined;
        if (!ssoModule) {
            throw new Error("SSOModule not found!");
        }

        this.ssoStore = ssoModule.vuexModule;
    }

    onRouterReady(evt: RouterReadyEvent) {
        this.menu = createMenu(evt.router);
        Vue.filter("AREA", (val: number) => (val / 10000).toFixed(4))
    }

    async beforeEnterAnyRoutes(http: HTTPClient) {
        if (this.apiCreated) {
            return;
        }
        this.apiCreated = true;

        const PoiApi = (await import("./api/PoiApi")).default;
        this.pointOfInterestApi = new PoiApi(http, this.ssoStore);

        const IconCategory = (await import ("./components/private/bookmarksIcons")).default;
        this.iconCategory  = new IconCategory();
    }

    public get poiApi(): PoiApi {
        return this.pointOfInterestApi;
    }

    public get iconCat(): IconCategory {
        return this.iconCategory;
    }
}
